import IconDashboard from '@mui/icons-material/Dashboard'
import IconHelp from '@mui/icons-material/HelpRounded'
import IconHome from '@mui/icons-material/HomeRounded'
import { Icon, Module, DiversityDimension, StaticView } from '../../shared/model'
import { ReactComponent as IconOverview } from '../../assets/menu/icon_overview.svg'
import { ReactComponent as IconPay } from '../../assets/menu/icon_pay.svg'
import { ReactComponent as IconCareer } from '../../assets/menu/icon_career.svg'
import { ReactComponent as IconTime } from '../../assets/menu/icon_time.svg'
import { ReactComponent as IconTraining } from '../../assets/menu/icon_training.svg'
import { ReactComponent as IconGender } from '../../assets/menu/icon_gender.svg'
import { ReactComponent as IconDisability } from '../../assets/menu/icon_disability.svg'
import { ReactComponent as IconOrigin } from '../../assets/menu/icon_origin.svg'
import { ReactComponent as IconAge } from '../../assets/menu/icon_age.svg'
import { ReactComponent as IconReport } from '../../assets/menu/icon_report.svg'
import { ReactComponent as IconUpload } from '../../assets/menu/icon_upload.svg'
import { ReactComponent as ETRLIcon } from '../../assets/menu/ETRL_KPI_icon.svg'
import { ReactComponent as PTAssistanceIcon } from '../../assets/menu/PT_assistance_icon.svg'
import { ReactComponent as LegalReportIcon } from '../../assets/menu/Legal_report_icon.svg'
import { ReactComponent as GeneralReportIcon } from '../../assets/menu/General_report_icon.svg'

const FsIcons: Icon[] = [
  {
    key: 'overview',
    icon: IconOverview,
  },
  {
    key: Module.PAY,
    icon: IconPay,
  },
  {
    key: Module.CAREER,
    icon: IconCareer,
  },
  {
    key: Module.WORKING_TIME,
    icon: IconTime,
  },
  {
    key: Module.TRAINING,
    icon: IconTraining,
  },
  {
    key: `${DiversityDimension.GENDER}`,
    icon: IconGender,
  },
  {
    key: `${DiversityDimension.DISABILITY}`,
    icon: IconDisability,
  },
  {
    key: `${DiversityDimension.ORIGIN}`,
    icon: IconOrigin,
  },
  {
    key: `${DiversityDimension.MIGRATION_BACKGROUND}`,
    icon: IconOrigin,
  },
  {
    key: `${DiversityDimension.AGE}`,
    icon: IconAge,
  },
  {
    key: StaticView.REPORTS,
    icon: IconReport,
  },
  {
    key: StaticView.ETL,
    icon: IconUpload,
  },
  {
    key: StaticView.UPLOAD,
    icon: IconUpload,
  },
  {
    key: StaticView.PTHOME,
    icon: IconHome,
  },
  {
    key: StaticView.PTKPIS,
    icon: ETRLIcon,
  },
  {
    key: StaticView.PTASSISSTANCE,
    icon: PTAssistanceIcon,
  },
  {
    key: StaticView.PTDATAUPLOADSTEPS,
    icon: IconUpload,
  },
  {
    key: 'help',
    icon: IconHelp,
  },
  {
      key: 'legalreport',
      icon: LegalReportIcon,
    },
    {
      key: 'generalreport',
      icon: GeneralReportIcon,
    },
]

export const getIcon = (key: string, params?: any): React.ReactNode => {
  const CustomIcon = FsIcons.find((icon) => icon.key === key)?.icon || IconDashboard
  const customParams = {
    width: 24,
    height: 24,
    ...params
  }
  return <CustomIcon {...customParams} />
}
